import type { CmpEvent } from "./types";

type Handler = (payload?: unknown) => void;

export class Emitter {
  private handlers: Record<string, Set<Handler>> = {};

  on(event: CmpEvent, cb: Handler) {
    (this.handlers[event] ||= new Set()).add(cb);
  }

  off(event: CmpEvent, cb: Handler) {
    this.handlers[event]?.delete(cb);
  }

  emit(event: CmpEvent, payload?: unknown) {
    this.handlers[event]?.forEach((cb) => {
      try { cb(payload); } catch (e) { console.warn("[cmp] listener error", e); }
    });
  }
}
